import { AppState } from '../store';

export const selectProductsLoading = (store: AppState) =>
  store.products.loading;

export const selectProductsCount = (store: AppState) =>
  store.products.itemCount;
